<template>
  <span
  :class="{ 'qp-info-icon': true, 'qp--ada-disabled': disableAdaCompliance }"
  tabindex="0" 
  title="Zip - Buy now pay later."
  role="button"
  aria-label="Info icon, when clicked, opens infographic about the option of buying this item with 4 installment payments">
    &#9432;
  </span>   
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class InfoButton extends Vue {
  
  @Prop({
    default: false
  }) disableAdaCompliance: boolean;

}
</script>